import { getEnumValues } from "sprint-common-web";

export enum MuxerType {
    Manzanita = 1,
    GPAC = 2
}

export const mapNumberToMuxerType = (typeNumber: number): MuxerType => {
    if (isNumberMuxerType(typeNumber)) {
        return typeNumber;
    }

    throw new Error("Incorrect MuxerType");
};

const isNumberMuxerType = (typeNumber: number) => {
    const muxerType = getEnumValues(MuxerType);

    return muxerType.some((muxer: MuxerType) => muxer === typeNumber);
};
